import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/static/TrustPilot_Cofidis_2025_10.webp")